/**
 * GeoData default values
 * will be populated after retrieving data from GeoAPI during the initial loading process.
 */
export default {
  countryCode: "",
  countryName: ""
};
